/*
 * @Author: Yolo
 * @Date: 2024-07-02 09:12:21
 * @Last Modified by:   Yolo
 * @Last Modified time: 2024-07-02 09:12:21
 * @Desc 领海基线数据
 */
export const baseLine = [
  {
    name: '大陆领海基线',
    options: {
      dashArray: [5, 5],
      weight: 2,
      minZoom: 2,
    },
    points: [
      {
        name: '山东高角（1）',
        lat: 37.4,
        lng: 122.705,
      },
      {
        name: '山东高角（2）',
        lat: 37.395,
        lng: 122.705,
      },
      {
        name: '镆耶岛（1）',
        lat: 36.96333333,
        lng: 122.57,
      },
      {
        name: '镆耶岛（2）',
        lat: 36.91833333,
        lng: 122.545,
      },
      {
        name: '镆耶岛（3）',
        lat: 36.895,
        lng: 122.5183333,
      },
      {
        name: '苏山岛',
        lat: 36.74666667,
        lng: 122.2633333,
      },
      {
        name: '朝连岛',
        lat: 35.89333333,
        lng: 120.885,
      },
      {
        name: '达山岛',
        lat: 35.00333333,
        lng: 119.9033333,
      },
      {
        name: '麻菜珩',
        lat: 33.36333333,
        lng: 121.3466667,
      },
      {
        name: '外磕脚',
        lat: 33.015,
        lng: 121.64,
      },
      {
        name: '佘山岛',
        lat: 31.42166667,
        lng: 122.2433333,
      },
      {
        name: '海礁',
        lat: 30.735,
        lng: 123.1566667,
      },
      {
        name: '东南礁',
        lat: 30.725,
        lng: 123.1616667,
      },
      {
        name: '两兄弟屿',
        lat: 30.16833333,
        lng: 122.945,
      },
      {
        name: '渔山列岛',
        lat: 28.88833333,
        lng: 122.275,
      },
      {
        name: '台州列岛（1）',
        lat: 28.39833333,
        lng: 121.9166667,
      },
      {
        name: '台州列岛（2）',
        lat: 28.39166667,
        lng: 121.9116667,
      },
      {
        name: '稻挑山',
        lat: 27.465,
        lng: 121.13,
      },
      {
        name: '东引岛',
        lat: 26.37666667,
        lng: 120.5066667,
      },
      {
        name: '东沙岛',
        lat: 26.15666667,
        lng: 120.405,
      },
      {
        name: '牛山岛',
        lat: 25.43,
        lng: 119.9383333,
      },
      {
        name: '乌丘屿',
        lat: 24.97666667,
        lng: 119.4783333,
      },
      {
        name: '东碇岛',
        lat: 24.16166667,
        lng: 118.2366667,
      },
      {
        name: '大柑山',
        lat: 23.53166667,
        lng: 117.6883333,
      },
      {
        name: '南澎列岛（1）',
        lat: 23.215,
        lng: 117.2483333,
      },
      {
        name: '南澎列岛（2）',
        lat: 23.205,
        lng: 117.2316667,
      },
      {
        name: '石碑山角',
        lat: 22.935,
        lng: 116.495,
      },
      {
        name: '针头岩',
        lat: 22.315,
        lng: 115.125,
      },
      {
        name: '佳蓬列岛',
        lat: 21.80833333,
        lng: 113.9666667,
      },
      {
        name: '围夹岛',
        lat: 21.56833333,
        lng: 112.7983333,
      },
      {
        name: '大帆石',
        lat: 21.46166667,
        lng: 112.3583333,
      },
      {
        name: '七洲列岛',
        lat: 19.975,
        lng: 111.2733333,
      },
      {
        name: '观帆',
        lat: 19.88333333,
        lng: 111.2133333,
      },
      {
        name: '大洲岛（1）',
        lat: 18.66166667,
        lng: 110.4933333,
      },
      {
        name: '大洲岛（2）',
        lat: 18.65666667,
        lng: 110.485,
      },
      {
        name: '双帆石',
        lat: 18.435,
        lng: 110.14,
      },
      {
        name: '陵水角',
        lat: 18.38333333,
        lng: 110.05,
      },
      {
        name: '东洲（1）',
        lat: 18.18333333,
        lng: 109.7016667,
      },
      {
        name: '东洲（2）',
        lat: 18.18333333,
        lng: 109.6966667,
      },
      {
        name: '锦母角',
        lat: 18.15833333,
        lng: 109.5733333,
      },
      {
        name: '深石礁',
        lat: 18.24333333,
        lng: 109.1266667,
      },
      {
        name: '西鼓岛',
        lat: 18.32166667,
        lng: 108.9516667,
      },
      {
        name: '莺歌嘴（1）',
        lat: 18.50333333,
        lng: 108.6883333,
      },
      {
        name: '莺歌嘴（2）',
        lat: 18.50666667,
        lng: 108.685,
      },
      {
        name: '莺歌嘴（3）',
        lat: 18.51666667,
        lng: 108.6766667,
      },
      {
        name: '莺歌嘴（4）',
        lat: 18.51833333,
        lng: 108.675,
      },
      {
        name: '感恩角',
        lat: 18.84166667,
        lng: 108.6216667,
      },
      {
        name: '四更沙角',
        lat: 19.19333333,
        lng: 108.6,
      },
      {
        name: '峻壁角',
        lat: 19.35166667,
        lng: 108.6433333,
      },
    ],
  },
  {
    name: '西沙群岛',
    points: [
      {
        name: '东岛（1）',
        lat: 16.675,
        lng: 112.7366667,
      },
      {
        name: '东岛（2）',
        lat: 16.66833333,
        lng: 112.7416667,
      },
      {
        name: '东岛（3）',
        lat: 16.66333333,
        lng: 112.745,
      },
      {
        name: '浪花礁（1）',
        lat: 16.07333333,
        lng: 112.5966667,
      },
      {
        name: '浪花礁（2）',
        lat: 16.03166667,
        lng: 112.545,
      },
      {
        name: '浪花礁（3）',
        lat: 16.025,
        lng: 112.53,
      },
      {
        name: '浪花礁（4）',
        lat: 16.01666667,
        lng: 112.4966667,
      },
      {
        name: '中建岛（1）',
        lat: 15.775,
        lng: 111.21,
      },
      {
        name: '中建岛（2）',
        lat: 15.77333333,
        lng: 111.2016667,
      },
      {
        name: '中建岛（3）',
        lat: 15.77333333,
        lng: 111.1966667,
      },
      {
        name: '中建岛（4）',
        lat: 15.775,
        lng: 111.1933333,
      },
      {
        name: '中建岛（5）',
        lat: 15.77833333,
        lng: 111.19,
      },
      {
        name: '中建岛（6）',
        lat: 15.78166667,
        lng: 111.1883333,
      },
      {
        name: '中建岛（7）',
        lat: 15.78666667,
        lng: 111.19,
      },
      {
        name: '北礁（1）',
        lat: 17.08166667,
        lng: 111.4483333,
      },
      {
        name: '北礁（2）',
        lat: 17.09,
        lng: 111.4483333,
      },
      {
        name: '北礁（3）',
        lat: 17.095,
        lng: 111.4533333,
      },
      {
        name: '北礁（4）',
        lat: 17.1,
        lng: 111.4633333,
      },
      {
        name: '北礁（5）',
        lat: 17.10833333,
        lng: 111.4866667,
      },
      {
        name: '北礁（6）',
        lat: 17.11666667,
        lng: 111.5166667,
      },
      {
        name: '北礁（7）',
        lat: 17.11833333,
        lng: 111.5266667,
      },
      {
        name: '北礁（8）',
        lat: 17.115,
        lng: 111.5333333,
      },
      {
        name: '赵述岛（1）',
        lat: 16.99833333,
        lng: 112.245,
      },
      {
        name: '赵述岛（3）',
        lat: 16.995,
        lng: 112.26,
      },
      {
        name: '赵述岛（3）',
        lat: 16.99,
        lng: 112.2766667,
      },
      {
        name: '北岛',
        lat: 16.97333333,
        lng: 112.305,
      },
      {
        name: '中岛',
        lat: 16.96,
        lng: 112.3266667,
      },
      {
        name: '南岛',
        lat: 16.94833333,
        lng: 112.3416667,
      },
      {
        name: '东岛（1）',
        lat: 16.675,
        lng: 112.7366667,
      },
    ],
  },
  {
    name: '钓鱼岛',
    points: [
      {
        name: '钓鱼岛1',
        lat: 25.735,
        lng: 123.4583333,
      },
      {
        name: '钓鱼岛2',
        lat: 25.73666667,
        lng: 123.4566667,
      },
      {
        name: '钓鱼岛3',
        lat: 25.74,
        lng: 123.4566667,
      },
      {
        name: '钓鱼岛4',
        lat: 25.745,
        lng: 123.4583333,
      },
      {
        name: '海豚岛',
        lat: 25.93,
        lng: 123.6783333,
      },
      {
        name: '下虎牙岛',
        lat: 25.93,
        lng: 123.685,
      },
      {
        name: '海星岛',
        lat: 25.92666667,
        lng: 123.6883333,
      },
      {
        name: '黄尾屿',
        lat: 25.92333333,
        lng: 123.69,
      },
      {
        name: '海龟岛',
        lat: 25.92166667,
        lng: 123.69,
      },
      {
        name: '长龙岛',
        lat: 25.72,
        lng: 123.5566667,
      },
      {
        name: '南小岛',
        lat: 25.72,
        lng: 123.5533333,
      },
      {
        name: '鲳鱼岛',
        lat: 25.73333333,
        lng: 123.46,
      },
      {
        name: '钓鱼岛1',
        lat: 25.735,
        lng: 123.4583333,
      },
    ],
  },
  {
    name: '赤尾屿',
    points: [
      {
        name: '赤尾屿',
        lat: 25.92166667,
        lng: 124.5616667,
      },
      {
        name: '望赤岛',
        lat: 25.92,
        lng: 124.5533333,
      },
      {
        name: '小赤尾岛',
        lat: 25.92166667,
        lng: 124.555,
      },
      {
        name: '赤背北岛',
        lat: 25.925,
        lng: 124.5583333,
      },
      {
        name: '赤背东岛',
        lat: 25.925,
        lng: 124.5616667,
      },
      {
        name: '赤尾屿',
        lat: 25.92166667,
        lng: 124.5616667,
      },
    ],
  },
  {
    name: '北部湾北部',
    points: [
      {
        name: '峻壁角',
        lat: 19.351667,
        lng: 108.643333,
      },
      {
        name: '神尖角',
        lat: 19.826667,
        lng: 109.158333,
      },
      {
        name: '兵马角',
        lat: 19.901667,
        lng: 109.261667,
      },
      {
        name: '斜阳岛',
        lat: 20.903333,
        lng: 109.206667,
      },
      {
        name: '涠洲岛',
        lat: 21.01,
        lng: 109.086667,
      },
      {
        name: '白须公礁',
        lat: 21.388333,
        lng: 108.205,
      },
      {
        name: '中越北部湾分界线第1界点',
        lat: 21.470139,
        lng: 108.101194,
      },
    ],
  },
  {
    name: '黄岩岛',
    points: [
      {
        name: '黄岩岛1',
        lat: 15.135,
        lng: 117.84833333333333,
      },
      {
        name: '黄岩岛2',
        lat: 15.123333333333333,
        lng: 117.84666666666666,
      },
      {
        name: '黄岩岛3',
        lat: 15.116666666666667,
        lng: 117.84333333333333,
      },
      {
        name: '黄岩岛4',
        lat: 15.11,
        lng: 117.83666666666667,
      },
      {
        name: '黄岩岛5',
        lat: 15.101666666666667,
        lng: 117.825,
      },
      {
        name: '黄岩岛6',
        lat: 15.105,
        lng: 117.73666666666666,
      },
      {
        name: '黄岩岛7',
        lat: 15.121666666666666,
        lng: 117.71833333333333,
      },
      {
        name: '黄岩岛8',
        lat: 15.211666666666666,
        lng: 117.71,
      },
      {
        name: '黄岩岛9',
        lat: 15.218333333333334,
        lng: 117.71333333333334,
      },
      {
        name: '黄岩岛10',
        lat: 15.223333333333333,
        lng: 117.72166666666666,
      },
      {
        name: '黄岩岛11',
        lat: 15.225,
        lng: 117.73166666666667,
      },
      {
        name: '黄岩岛12',
        lat: 15.225,
        lng: 117.74,
      },
      {
        name: '黄岩岛13',
        lat: 15.16,
        lng: 117.82833333333333,
      },
      {
        name: '黄岩岛14',
        lat: 15.15,
        lng: 117.84,
      },
      {
        name: '黄岩岛15',
        lat: 15.141666666666667,
        lng: 117.84666666666666,
      },
      {
        name: '黄岩岛1',
        lat: 15.135,
        lng: 117.84833333333333,
      },
    ],
  },
  {
    name: '临海基线外12海里',
    options: {
      dashArray: [5, 5],
      weight: 1,
      minZoom: 2,
    },
    points: [
      {
        name: '',
        lat: 19.400475332040006,
        lng: 108.43896965016168,
      },
      {
        name: '',
        lat: 19.242099128176797,
        lng: 108.3958586381782,
      },
      {
        name: '',
        lat: 19.21144812121886,
        lng: 108.39016411767574,
      },
      {
        name: '',
        lat: 19.180360640385725,
        lng: 108.38957041360386,
      },
      {
        name: '',
        lat: 18.828772774694308,
        lng: 108.4117404282734,
      },
      {
        name: '',
        lat: 18.809440578778425,
        lng: 108.41395426107904,
      },
      {
        name: '',
        lat: 18.486226090499247,
        lng: 108.46772009332479,
      },
      {
        name: '',
        lat: 18.447624982239194,
        lng: 108.47838425895947,
      },
      {
        name: '',
        lat: 18.411867457146545,
        lng: 108.4969348144334,
      },
      {
        name: '',
        lat: 18.392623356063957,
        lng: 108.51263999170415,
      },
      {
        name: '',
        lat: 18.392623356063957,
        lng: 108.51263999170415,
      },
      {
        name: '',
        lat: 18.392147743687847,
        lng: 108.51201197504474,
      },
      {
        name: '',
        lat: 18.382157701486577,
        lng: 108.52034767636927,
      },
      {
        name: '',
        lat: 18.368714644865182,
        lng: 108.5326398635561,
      },
      {
        name: '',
        lat: 18.365384878405575,
        lng: 108.53597285140175,
      },
      {
        name: '',
        lat: 18.34146549124171,
        lng: 108.56476465908344,
      },
      {
        name: '',
        lat: 18.160013445781786,
        lng: 108.82792212455026,
      },
      {
        name: '',
        lat: 18.14096991184573,
        lng: 108.8617978693904,
      },
      {
        name: '',
        lat: 18.062731580949716,
        lng: 109.03661416506209,
      },
      {
        name: '',
        lat: 18.04762093202632,
        lng: 109.0848541383913,
      },
      {
        name: '',
        lat: 17.96270434676164,
        lng: 109.53093842398604,
      },
      {
        name: '',
        lat: 17.958789152117024,
        lng: 109.57336870538566,
      },
      {
        name: '',
        lat: 17.963167557189408,
        lng: 109.61579861629751,
      },
      {
        name: '',
        lat: 17.98634953831852,
        lng: 109.73023065617687,
      },
      {
        name: '',
        lat: 17.98704839799646,
        lng: 109.73830553957656,
      },
      {
        name: '',
        lat: 17.99677593438641,
        lng: 109.7749036959793,
      },
      {
        name: '',
        lat: 18.01263719430467,
        lng: 109.80910050098582,
      },
      {
        name: '',
        lat: 18.21235757746712,
        lng: 110.15721665853519,
      },
      {
        name: '',
        lat: 18.212536115183912,
        lng: 110.15752824642131,
      },
      {
        name: '',
        lat: 18.264130590426323,
        lng: 110.24747155256017,
      },
      {
        name: '',
        lat: 18.269845335788677,
        lng: 110.25687116773076,
      },
      {
        name: '',
        lat: 18.4895435992388,
        lng: 110.599084119246,
      },
      {
        name: '',
        lat: 18.492938755414066,
        lng: 110.60474725451007,
      },
      {
        name: '',
        lat: 18.513095231557397,
        lng: 110.63287096323438,
      },
      {
        name: '',
        lat: 18.537415338468417,
        lng: 110.65709384925643,
      },
      {
        name: '',
        lat: 18.565219284454322,
        lng: 110.67673625570565,
      },
      {
        name: '',
        lat: 19.782380675708794,
        lng: 111.39575521924793,
      },
      {
        name: '',
        lat: 19.86669390072503,
        lng: 111.45106003678795,
      },
      {
        name: '',
        lat: 21.287206376332133,
        lng: 112.48926349592516,
      },
      {
        name: '',
        lat: 21.37410974078667,
        lng: 112.84832477779729,
      },
      {
        name: '',
        lat: 21.612999769562858,
        lng: 114.0117746213028,
      },
      {
        name: '',
        lat: 21.627914573762563,
        lng: 114.05880433190471,
      },
      {
        name: '',
        lat: 22.133814228565875,
        lng: 115.21591660669814,
      },
      {
        name: '',
        lat: 22.135930946632595,
        lng: 115.2206694538701,
      },
      {
        name: '',
        lat: 22.752032982707625,
        lng: 116.58253368098066,
      },
      {
        name: '',
        lat: 23.01907667439758,
        lng: 117.31139526446105,
      },
      {
        name: '',
        lat: 23.037545778228825,
        lng: 117.35026138864326,
      },
      {
        name: '',
        lat: 23.047531929480247,
        lng: 117.36691480228906,
      },
      {
        name: '',
        lat: 23.057794400419525,
        lng: 117.38248493962479,
      },
      {
        name: '',
        lat: 23.374045536426774,
        lng: 117.82225495714354,
      },
      {
        name: '',
        lat: 23.407328164997537,
        lng: 117.85884852029042,
      },
      {
        name: '',
        lat: 24.01582791316224,
        lng: 118.38918474227589,
      },
      {
        name: '',
        lat: 24.814006004341643,
        lng: 119.60634926444325,
      },
      {
        name: '',
        lat: 24.84170342597344,
        lng: 119.64086690071152,
      },
      {
        name: '',
        lat: 25.29449766941108,
        lng: 120.10091614072037,
      },
      {
        name: '',
        lat: 25.330177218916358,
        lng: 120.12998074474307,
      },
      {
        name: '',
        lat: 26.056167564973816,
        lng: 120.59738360874704,
      },
      {
        name: '',
        lat: 26.080094557125772,
        lng: 120.61061072114032,
      },
      {
        name: '',
        lat: 26.29294855761794,
        lng: 120.70934382753936,
      },
      {
        name: '',
        lat: 27.359218336824274,
        lng: 121.32183362778922,
      },
      {
        name: '',
        lat: 28.271844879298502,
        lng: 122.0932158221274,
      },
      {
        name: '',
        lat: 28.281782601025295,
        lng: 122.10118921859802,
      },
      {
        name: '',
        lat: 28.28844206447984,
        lng: 122.10619498351035,
      },
      {
        name: '',
        lat: 28.290849272958766,
        lng: 122.1079764660761,
      },
      {
        name: '',
        lat: 28.78032529871008,
        lng: 122.46676259251852,
      },
      {
        name: '',
        lat: 28.806315027065335,
        lng: 122.4829524969206,
      },
      {
        name: '',
        lat: 30.085186696672764,
        lng: 123.1548613683846,
      },
      {
        name: '',
        lat: 30.105288924702336,
        lng: 123.16410136955227,
      },
      {
        name: '',
        lat: 30.661548434618894,
        lng: 123.38179912857413,
      },
      {
        name: '',
        lat: 30.696889613420034,
        lng: 123.39166722111464,
      },
      {
        name: '',
        lat: 30.73316925077156,
        lng: 123.39391130442975,
      },
      {
        name: '',
        lat: 30.769184263487354,
        lng: 123.38844866380258,
      },
      {
        name: '',
        lat: 30.803739069800873,
        lng: 123.37545234151123,
      },
      {
        name: '',
        lat: 30.813745814174766,
        lng: 123.37047120620609,
      },
      {
        name: '',
        lat: 30.851852871578757,
        lng: 123.34538988506789,
      },
      {
        name: '',
        lat: 30.884327484052818,
        lng: 123.31117919674621,
      },
      {
        name: '',
        lat: 31.53538926461731,
        lng: 122.44684825119992,
      },
      {
        name: '',
        lat: 33.07648559734355,
        lng: 121.8667352321041,
      },
      {
        name: '',
        lat: 33.10421839065398,
        lng: 121.85332377459848,
      },
      {
        name: '',
        lat: 33.129944292584646,
        lng: 121.8350950043826,
      },
      {
        name: '',
        lat: 33.47867753874594,
        lng: 121.54218507441807,
      },
      {
        name: '',
        lat: 33.480095099638675,
        lng: 121.54097810813232,
      },
      {
        name: '',
        lat: 34.991497124410785,
        lng: 120.21648228170581,
      },
      {
        name: '',
        lat: 35.74639137151892,
        lng: 121.05204133417244,
      },
      {
        name: '',
        lat: 36.586514813658425,
        lng: 122.4103914354418,
      },
      {
        name: '',
        lat: 36.733477028160436,
        lng: 122.66320851166603,
      },
      {
        name: '',
        lat: 36.760581589233794,
        lng: 122.70120818993895,
      },
      {
        name: '',
        lat: 36.783879383124244,
        lng: 122.72787838263334,
      },
      {
        name: '',
        lat: 36.80944876905267,
        lng: 122.75274582859268,
      },
      {
        name: '',
        lat: 36.83788083637342,
        lng: 122.7721732808763,
      },
      {
        name: '',
        lat: 36.882835719180996,
        lng: 122.79726778172643,
      },
      {
        name: '',
        lat: 36.91594574166617,
        lng: 122.81158587924915,
      },
      {
        name: '',
        lat: 37.34732676671402,
        lng: 122.94775920433403,
      },
      {
        name: '',
        lat: 37.395931624160845,
        lng: 122.95544578872705,
      },
      {
        name: '',
        lat: 37.400930982755206,
        lng: 122.95546130310628,
      },
      {
        name: '',
        lat: 37.43983108568427,
        lng: 122.9507685891028,
      },
    ],
  },
  {
    name: '临海基线外12海里',
    options: {
      dashArray: [5, 5],
      weight: 1,
      minZoom: 2,
    },
    points: [
      {
        name: '',
        lat: 21.345594372646456,
        lng: 107.93331294753797,
      },
      {
        name: '',
        lat: 21.317504414049996,
        lng: 107.96263580067864,
      },
      {
        name: '',
        lat: 21.235780917802693,
        lng: 108.06640995337658,
      },
      {
        name: '',
        lat: 21.206527359841438,
        lng: 108.11590949799125,
      },
      {
        name: '',
        lat: 20.84246315467876,
        lng: 108.96478637915014,
      },
      {
        name: '',
        lat: 20.813399449063773,
        lng: 108.99752208586229,
      },
      {
        name: '',
        lat: 19.99585578835578,
        lng: 109.04354900021677,
      },
      {
        name: '',
        lat: 19.984808731086584,
        lng: 109.0283491160777,
      },
      {
        name: '',
        lat: 19.96964228795034,
        lng: 109.00980907907919,
      },
      {
        name: '',
        lat: 19.4942089781805,
        lng: 108.4947885530011,
      },
      {
        name: '',
        lat: 19.46412494217675,
        lng: 108.46816443970864,
      },
      {
        name: '',
        lat: 19.429719462132926,
        lng: 108.44828595597426,
      },
      {
        name: '',
        lat: 19.400475332040006,
        lng: 108.43896965016168,
      },
    ],
  },
]
